import { render, staticRenderFns } from "./MealList.vue?vue&type=template&id=56bb3ea9&scoped=true"
import script from "./MealList.vue?vue&type=script&lang=js"
export * from "./MealList.vue?vue&type=script&lang=js"
import style0 from "./MealList.vue?vue&type=style&index=0&id=56bb3ea9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb3ea9",
  null
  
)

export default component.exports